import { useState } from "react";
import { Link } from "react-router-dom";
import { FiMenu, FiX } from "react-icons/fi";

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav
      className="app-nav flex items-center justify-between px-6 md:px-10 py-4 
                 fixed top-0 w-full z-50"
    >
      {/* logo */}
     <div className="order-1 md:order-none flex items-center gap-2">
      <img
        src="/logoM.png"
        alt="Moyal Glass"
        className="h-10 md:h-14 w-auto object-contain"
      />
    </div>

{/*button for mobile*/}
  <button
    className="order-2 md:order-none md:hidden text-slate-100 text-3xl focus:outline-none"
    onClick={() => setMenuOpen(!menuOpen)}
  >
    {menuOpen ? <FiX /> : <FiMenu />}
  </button>
      {/* full screren menu*/}
      <ul
        className="hidden md:flex flex-row justify-center gap-10 text-lg font-medium text-slate-200 md:order-2"
        dir="rtl"
      >
        <li>
          <Link to="/" className="hover:text-white transition-colors">
            דף הבית
          </Link>
        </li>
        <li>
          <Link to="/gallery" className="hover:text-white transition-colors">
            גלריה
          </Link>
        </li>
        <li>
          <Link to="/projects" className="hover:text-white transition-colors">
            פרוייקטים
          </Link>
        </li>
        <li>
          <Link to="/about" className="hover:text-white transition-colors">
            אודות
          </Link>
        </li>
      </ul>

      {/* contact */}
      <a
        href="#contact"
        className="hidden md:flex btn-primary items-center gap-2 md:order-3"
      >
        <i className="bi bi-telephone"></i>
        צור קשר
      </a>

      {/* mobile openning menu*/}
      {menuOpen && (
        <>
          <button
            type="button"
            aria-label="Close menu backdrop"
            className="fixed inset-0 top-[72px] bg-black/65 backdrop-blur-[2px] md:hidden"
            onClick={() => setMenuOpen(false)}
          />

          <div
            className="menu-panel absolute top-full left-0 w-full py-6
                       flex flex-col items-center gap-5 text-lg font-medium
                       text-slate-100 md:hidden"
            dir="rtl"
          >
            <Link
              to="/"
              className="hover:text-white transition-colors"
              onClick={() => setMenuOpen(false)}
            >
              דף הבית
            </Link>
            <Link
              to="/gallery"
              className="hover:text-white transition-colors"
              onClick={() => setMenuOpen(false)}
            >
              גלריה
            </Link>
            <Link
              to="/projects"
              className="hover:text-white transition-colors"
              onClick={() => setMenuOpen(false)}
            >
              פרוייקטים
            </Link>
            <Link
              to="/about"
              className="hover:text-white transition-colors"
              onClick={() => setMenuOpen(false)}
            >
              אודות
            </Link>
            <a
              href="#contact"
              className="btn-primary flex items-center gap-2"
              onClick={() => setMenuOpen(false)}
            >
              <i className="bi bi-telephone"></i>
              צור קשר
            </a>
          </div>
        </>
      )}
    </nav>
  );
}
